export const suffixParser = (base: string) => {
  const stripLetterSuffixRegex = /[^0-9-]/g;
  const takeLetterSuffixRegex = /[^a-zA-Z ]/g;

  const justTheHouseNumber = base.replace(stripLetterSuffixRegex, '').trim();
  const justTheHouseSuffix = base.replace(takeLetterSuffixRegex, '').trim();

  const houseNumber =
    justTheHouseNumber === '' ? undefined : Number(justTheHouseNumber);

  return {
    houseNumber,
    houseSuffix: justTheHouseSuffix,
  };
};

export const houseNumberParser = (baseHouseNumber: string) => {
  if (!baseHouseNumber || baseHouseNumber === '') {
    return {};
  }

  // Split address
  // e.g. 10-10, 10-12A
  if (baseHouseNumber.includes('-')) {
    const left = baseHouseNumber.split('-')[0].trim();
    const right = baseHouseNumber.split('-')[1].trim();

    const { houseNumber, houseSuffix } = suffixParser(left);
    const { houseNumber: houseNumberTo, houseSuffix: houseNumberToSuffix } =
      suffixParser(right);

    return {
      houseNumber,
      houseSuffix,
      houseNumberTo,
      houseNumberToSuffix,
    };
  }

  // Address with a suffix letter
  // e.g. House 11A
  if (Number.isNaN(Number(baseHouseNumber))) {
    const { houseNumber, houseSuffix } = suffixParser(baseHouseNumber);

    return {
      houseNumber,
      houseSuffix,
    };
  }

  // Just a house number, align the types
  return {
    houseNumber: Number(baseHouseNumber),
  };
};
